import LinkToDocusaurus from '../LinkToDocusaurus'
import { BsInfoCircle } from 'react-icons/bs'
import { suts } from '../../docs-routes'

const LinkToSutsDoc = () =>
  <span>
    <BsInfoCircle
      aria-hidden
      size={13}
      style={{ paddingRight: '0.5em' }}
    />
    <LinkToDocusaurus path={suts}>
      SUTs user guide
    </LinkToDocusaurus>
  </span>

export default LinkToSutsDoc
